module.exports = __webpack_public_path__ + "static/media/ic_arrow_left.f5acb9c2.svg";